import { PlanPackageDetails } from "features/types";
import { get } from "./http";

const BASE = "plan_packages";

class PlanPackageService {
  find() {
    return get({
      url: `${BASE}/find`,
      params: {
        size: 999,
      },
    }).then((data: any) => data.content) as Promise<PlanPackageDetails[]>;
  }
}

export default new PlanPackageService();
